rwgps.ns('pages.home', function() {
  const ns = this
  let detailsRef
  let stepsRef
  let onScroll
  let photoRefs
  let numberRefs
  let numberLineRefs
  let detailRefs
  let step = 1

  ns.init = () => {
    stepsRef = $('.steps').get(0)
    detailsRef = $('.steps .details').get(0)
    photoRefs = $('.steps .photos img').toArray()
    numberRefs = $('.steps .number').toArray()
    numberLineRefs = $('.steps .number img').toArray()
    detailRefs = $('.steps .detail').toArray()
    let scrollAnimation
    window.addEventListener('scroll', () => {
      if (scrollAnimation) {
        window.cancelAnimationFrame(scrollAnimation)
      }
      scrollAnimation = window.requestAnimationFrame(onScroll)
    })
    onScroll()
  }

  const setStep = newStep => {
    $(detailRefs[step-1]).removeClass('active')
    $(numberRefs[step-1]).removeClass('active')
    step = newStep
    $(detailRefs[step-1]).addClass('active')
    $(numberRefs[step-1]).addClass('active')

    switch (step) {
      case 1:
        $(numberLineRefs[0]).removeClass('active')
        $(numberLineRefs[1]).removeClass('active')
        break;
      case 2:
        $(numberLineRefs[0]).addClass('active')
        $(numberLineRefs[1]).removeClass('active')
        break;
      case 3:
        $(numberLineRefs[0]).addClass('active')
        $(numberLineRefs[1]).addClass('active')
        break;
    }
  }

  onScroll = () => {
    if (window.pageYOffset >= stepsRef.offsetTop) {
      if (window.pageYOffset >= photoRefs[2].offsetTop) {
        detailsRef.style.position = 'absolute'
        detailsRef.style.top = photoRefs[2].offsetTop + 'px'
      } else {
        detailsRef.style.position = 'fixed'
        detailsRef.style.top = 0
      }
    } else {
      detailsRef.style.position = 'relative'
      detailsRef.style.top = 0
    }

    const offsetBuffer = 400
    if (window.pageYOffset > photoRefs[2].offsetTop - offsetBuffer) {
      if (step !== 3) {
        setStep(3)
      }
    } else if (window.pageYOffset > photoRefs[1].offsetTop - offsetBuffer) {
      if (step !== 2) {
        setStep(2)
      }
    } else {
      if (step !== 1) {
        setStep(1)
      }
    }
  }
})

rwgps.ns('pages.marketing', function() {
  const ns = this
  let onScroll

  const scrollYOffset = window.innerHeight - 50
  const isAboveFold = el => window.pageYOffset + scrollYOffset > el.offsetTop

  ns.initFeatureFade = () => {
    if (window.innerWidth < 1053) { return }
    let scrollAnimation
    window.addEventListener('scroll', () => {
      if (scrollAnimation) {
        window.cancelAnimationFrame(scrollAnimation)
      }
      scrollAnimation = window.requestAnimationFrame(onScroll)
    })
    // add the faded out / translated class to stuff
    $('.feature-breakdown .detail, .feature-breakdown .image').each(function () {
      if (!isAboveFold(this)) {
        $(this).addClass('below-fold')
      }
    })
  }

  onScroll = () => {
    $('.below-fold').each(function () {
      if (isAboveFold(this)) {
        $(this).removeClass('below-fold')
      }
    })
  }
})



// WEBPACK FOOTER //
// ./public/javascripts/pages/home.js